module.exports = __webpack_public_path__ + "static/media/6.bba2f956.jpg";